import * as React from 'react'

interface IconProps {
	size?: number
	color?: string
	className?: string
}

export const UndoIcon = ({ size = 24, color = 'currentColor', className }: IconProps) => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 24 24"
		fill="none"
		stroke={color}
		className={className}
		strokeWidth="2"
		strokeLinecap="round"
		strokeLinejoin="round"
	>
		<path d="M3 7v6h6" />
		<path d="M3 13c0-4.97 4.03-9 9-9 4.97 0 9 4.03 9 9s-4.03 9-9 9c-2.49 0-4.74-1.01-6.36-2.64" />
	</svg>
)
